import 'react-perfect-scrollbar/dist/css/styles.css';
import 'src/assets/css/reset.css';
import 'react-image-gallery/styles/css/image-gallery.css';

import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';

import App from 'src/App';
import store from 'src/redux/store';

import ErrorBoundary from './views/Errors/ErrorBoundary';

ReactDOM.render(
  <ErrorBoundary>
    <ReduxProvider store={store}>
      <App />
    </ReduxProvider>
  </ErrorBoundary>,
  document.getElementById('root'),
);
